import HttpClient from "@api/clients/httpClient";
import { Filter, Options, Paging, Sorting } from "@api/models/HttpClientModels";
import OrderRequest from "../models/edit/OrderRequest";
import Order from "../models/list/Order";
import OrderFilter from "../models/list/OrderFilter";
import OrderRepeatContainer from "../models/list/OrderRepeatContainer";

const config = {
    endpoint: "orders",
};

export default class OrderService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new OrderFilter());
    }

    findAsync = async (filter: OrderFilter, sorting: Sorting, paging: Paging, options: Options, optionalUrl?: string) => {
        return await this.httpClient.findAsync<Order[]>(filter, paging, sorting, options, optionalUrl);
    };

    getAsync = async (id: string, options: Options, optionalUrl?: string) => {
        return await this.httpClient.getAsync<Order>(id, options, optionalUrl);
    };

    getWithRecalculatedAmountAsync = async (id: string) => {
        return await this.httpClient.getAsync<OrderRepeatContainer>(id, {}, 'recalculate-amount');
    };

    postAsync = async (order: OrderRequest) => {
        return await this.httpClient.postAsync<Order>(order);
    }
}